<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateDorm)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Dorm - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Agency Name</label>
                  <md-input v-model="name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider
                name="address"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Address</label>
                  <md-input v-model="address" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
            <!--            <ValidationProvider-->
            <!--              name="main_user"-->
            <!--              v-slot="{ passed, failed }"-->
            <!--            >-->
            <!--              <md-field-->
            <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
            <!--              >-->
            <!--                <md-icon>add_location</md-icon>-->
            <!--                <label>Main User</label>-->
            <!--                <md-select v-model="main_user" name="main_user">-->
            <!--                  <md-option value="">Select Main User</md-option>-->
            <!--                  <md-option v-for="c in main_users" v-bind:key="c.id" :value="c.id">{{ c.first_name }} {{ c.last_name }}</md-option>-->
            <!--                </md-select>-->

            <!--              </md-field>-->
            <!--            </ValidationProvider>-->
            <!--        </div>-->

            <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
            <!--          <ValidationProvider-->
            <!--            name="end_date"-->
            <!--            v-slot="{ passed, failed }"-->
            <!--          >-->
            <!--            <md-datepicker :class="[{ 'md-error': failed }, { 'md-valid': passed }]" v-model="end_date" md-immediately>-->
            <!--              <label>End Date</label>-->
            <!--              <slide-y-down-transition>-->
            <!--                <md-icon class="error" v-show="failed">close</md-icon>-->
            <!--              </slide-y-down-transition>-->
            <!--              <slide-y-down-transition>-->
            <!--                <md-icon class="success" v-show="passed">done</md-icon>-->
            <!--              </slide-y-down-transition>-->
            <!--            </md-datepicker>-->

            <!--          </ValidationProvider>-->
            <!--        </div>-->

            <!--        <div class="md-layout-item md-size-33 md-small-size-100">-->
            <!--            <ValidationProvider-->
            <!--              name="country"-->
            <!--              v-slot="{ passed, failed }"-->
            <!--            >-->
            <!--              <md-field-->
            <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
            <!--              >-->
            <!--                <md-icon>add_location</md-icon>-->
            <!--                <label>Country</label>-->
            <!--                <md-select v-model="country" name="country">-->
            <!--                  <md-option value="">Select Country</md-option>-->
            <!--                  <md-option v-for="c in countries" v-bind:key="c.id" :value="c.id">{{ c.name }}</md-option>-->
            <!--                </md-select>-->

            <!--              </md-field>-->
            <!--            </ValidationProvider>-->
            <!--        </div>-->

            <!--        <div class="md-layout-item md-size-50 md-small-size-100">-->
            <!--          <ValidationProvider-->
            <!--              name="email"-->
            <!--              v-slot="{ passed, failed }"-->
            <!--            >-->
            <!--              <md-field-->
            <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
            <!--              >-->
            <!--                <md-icon>attach_money</md-icon>-->
            <!--                <label>Email</label>-->
            <!--                <md-input v-model="email" type="text"> </md-input>-->

            <!--                <slide-y-down-transition>-->
            <!--                  <md-icon class="error" v-show="failed">close</md-icon>-->
            <!--                </slide-y-down-transition>-->
            <!--                <slide-y-down-transition>-->
            <!--                  <md-icon class="success" v-show="passed">done</md-icon>-->
            <!--                </slide-y-down-transition>-->

            <!--              </md-field>-->
            <!--            </ValidationProvider>-->
            <!--        </div>-->

            <!--        <div class="md-layout-item md-size-50 md-small-size-100">-->
            <!--          <ValidationProvider-->
            <!--              name="phone"-->
            <!--              rules="numeric"-->
            <!--              v-slot="{ passed, failed }"-->
            <!--            >-->
            <!--              <md-field-->
            <!--                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"-->
            <!--              >-->
            <!--                <md-icon>article</md-icon>-->
            <!--                <label>Phone</label>-->
            <!--                <md-input v-model="phone" type="text"> </md-input>-->

            <!--                <slide-y-down-transition>-->
            <!--                  <md-icon class="error" v-show="failed">close</md-icon>-->
            <!--                </slide-y-down-transition>-->
            <!--                <slide-y-down-transition>-->
            <!--                  <md-icon class="success" v-show="passed">done</md-icon>-->
            <!--                </slide-y-down-transition>-->

            <!--              </md-field>-->
            <!--            </ValidationProvider>-->
            <!--        </div>-->

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="lat" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Latitude</label>
                  <md-input v-model="lat" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="long" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Longitude</label>
                  <md-input v-model="long" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider name="status" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>rule</md-icon>
                  <label>Status</label>
                  <md-select v-model="status" name="status">
                    <md-option value="">Select Status</md-option>
                    <md-option value="1">Full Active</md-option>
                    <md-option value="2">Active</md-option>
                    <md-option value="3">Inactive</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Dorm
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dormID: null,

      countries: [],
      main_users: [],

      name: null,
      address: null,
      main_user: null,
      country: null,
      end_date: null,
      email: null,
      phone: null,
      lat: null,
      long: null,
      status: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateDorm() {
      let data = {
        name: this.name,
        address: this.address,
        // main_user: this.main_user,
        // country: this.country,
        // end_date: this.end_date,
        // email: this.email,
        // phone: this.phone,
        lat: this.lat,
        long: this.long,
        status: this.status
      };
      var post_data = {};
      for (const field in data) {
        if (
          data[field] === null ||
          data[field] === undefined ||
          data[field] === ""
        ) {
          continue;
        }
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          post_data[field] = data[field];
        }
      }
      this.$store
        .updateDorm(post_data, this.dormID)
        .then(response => {
          this.$notify({
            message: "Dorm updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.dormID = this.$route.params.id;
    // this.$store.getCountries().then(response => {
    //   this.countries = response.data.results
    // }).catch(error => {
    //   this.$notify({
    //     message: error.message,
    //     icon: 'add_alert',
    //     type: "warning",
    //     verticalAlign: "top",
    //   })
    // })
    // var params = {role: 5} // dorm users
    // this.$store.getUsers(params).then(response => {
    //   this.main_users = response.data.results
    // }).catch(error => {
    //   this.$notify({
    //     message: error.message,
    //     icon: 'add_alert',
    //     type: "warning",
    //     verticalAlign: "top",
    //   })
    // })
  }
};
</script>
<style>
.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
